<template>
  <div class="footer">
    <div class="top-banner" v-if="topBanner == 0">
      <div class="row">
        <p>为金融行业提供数字化解决方案</p>
        <router-link to="/solution/digitalize">
          <button>详情点击</button>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="logo-box clearfix">
        <img src="~images/base/logo-footer.png"
             alt="">
        <p>让数字产生价值，用科技洞见决策</p>
      </div>
      <div class="center clearfix">
        <div class="left">
          <dl>
            <dt>关于我们</dt>
            <dd>
              <router-link :to="{path:'/about',query:{id:0}}">公司介绍</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/about',query:{id:1}}">团队介绍</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/about',query:{id:2}}">资质荣誉</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/about',query:{id:3}}">合作客户</router-link>
            </dd>
          </dl>
          <dl>
            <dt>核心技术与产品</dt>
            <dd>
              <router-link :to="{path:'/coreTechnology',query:{id:0}}">数据技术</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/coreTechnology',query:{id:1}}">多方安全计算</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/coreTechnology',query:{id:2}}">智慧营销</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/coreTechnology',query:{id:3}}">智能金融风控服务</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/coreTechnology',query:{id:4}}">数字人民币</router-link>
            </dd>
          </dl><!-- 
          <dl>
            <dt>核心产品</dt>
            <dd>
              <router-link :to="{path:'/product',query:{id:0}}">技术中台产品</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/product',query:{id:1}}">金融科技产品</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/product',query:{id:2}}">AI产品</router-link>
            </dd>
            <dd>
              <router-link :to="{path:'/product',query:{id:3}}">区块链产品</router-link>
            </dd>
          </dl> -->
        </div>

        <div class="right">
          <div class="title">联系我们</div>
          <div class="r-box">

            <dl>
              <dt>
                <img src="~images/base/ewm.png"
                     alt="">
              </dt>
              <dd>扫码关注微信公众号</dd>
            </dl>
            <div class="top">
              <p>联系地址：北京市西城区新街口外大街28号C座3层315号</p>
              <p>联系电话：010-58351122</p>
              <p>传真： 010-58502099</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom clearfix" v-if="temporaryDel">
        <p>友情链接</p>
        <ul>
          <ul>
            <li><a href="https://www.umfintech.com"
                 target="_blank"> 北京鑫毅数字科技有限公司</a> </li>
            <li><a href="http://www.haili.com.cn/"
                 target="_blank">海联金汇</a> </li>
            <!-- <li>中国电子学会区块链分会</li>
            <li>中关村网金院</li>
            <li>信通院</li>
            <li>清华金融评论</li>
            <li>零壹财经</li> -->
          </ul>

        </ul>
      </div>
      <div class="bq">
        <p>版权所有 北京鑫毅数字科技有限公司</p>
        <p>X5 Digital Technology Co. Ltd.</p>
        <p><a href="https://beian.miit.gov.cn"
             target="_blank">京ICP备2020035227号</a></p>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'UmfFooter',
  data() {
    return {
      temporaryDel: false
    }
  },
  props: {
    topBanner: {
      default: 0,
      type: Number
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #242424;
  .top-banner {
    width: 100%;
    height: 110px;
    background: #f8555c;
    text-align: center;
    .row {
      background-image: url(~images/index/footer-bg.png);
      text-align: center;
      background-repeat: no-repeat;
    }
    p {
      display: inline-block;
      font-size: 32px;
      color: #ffffff;
      line-height: 110px;
    }
    button {
      background: #fa6268;
      height: 50px;
      width: 158px;
      border: 1px solid #fcbbbe;
      outline: none;
      color: #ffffff;
      font-size: 20px;
      margin-left: 65px;
      position: relative;
      top: -5px;
      cursor: pointer;
    }
  }

  .logo-box {
    padding-top: 34px;
    height: 80px;
    img {
      float: left;
      width: 72px;
      height: 44px;
    }
    p {
      float: left;
      line-height: 42px;
      color: #ffffff;
      padding-left: 20px;
      font-size: 18px;
    }
  }
  .center {
    .left {
      float: left;
      width: 700px;
      color: #ffffff;
      padding-left: 100px;
    box-sizing: border-box;
      dl {
        float: left;
        width: 130px;
        margin-right: 128px;
        // text-align: center;
        dt {
          font-size: 16px;
          line-height: 35px;
          border-bottom: 2px solid #505050;
          margin-bottom: 20px;
          padding-bottom: 15px;
        }
        dd {
          font-size: 14px;
          line-height: 30px;
          color: #cccccc;
        }
      }
    }
    .right {
      float: left;
      width: 500px;
      color: #ffffff;
      .title {
        font-size: 16px;
        line-height: 35px;
        margin-bottom: 10px;
      }
      .top {
        float: left;
        padding-left: 16px;
        p {
          font-size: 14px;
          line-height: 30px;
          color: #cccccc;
        }
      }
      dl {
        float: left;
        margin-top: 10px;
        dt {
        }
        dd {
          color: #959595;
          font-size: 12px;
        }
      }
    }
  }
  .bottom {
    padding-top: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #393939;
    p {
      float: left;
      font-size: 14px;
      color: #ffffff;
      line-height: 13px;
      padding-right: 30px;
    }
    ul {
      float: left;
      li {
        float: left;
        padding: 0 20px;
        color: #ffffff;
        font-size: 14px;
        color: #959595;
        border-right: 1px solid #959595;
        line-height: 14px;
      }
    }
  }
  .bq {
    text-align: center;
    color: #959595;
    padding: 10px 0;
    padding-top: 60px;
    font-size: 14px;
    p {
      line-height: 25px;
    }
  }
}
</style>